export const KNOWLEDGE_ALLOWED_EXTENSIONS = ['pdf', 'txt', 'md']

export const KNOWLEDGE_TYPE_LABELS = {
    methodology: 'Metodologia',
    system_doc: 'Documentação de sistema',
    pmo: 'PMO',
    policy: 'Política',
    other: 'Outro',
}

export const KNOWLEDGE_SCOPE_LABELS = {
    tenant: 'Toda a organização',
    module: 'Módulo específico',
}

export const KNOWLEDGE_STATUS_LABELS = {
    uploading: 'Processando',
    processing: 'Processando',
    ready: 'Ativo',
    error: 'Erro',
    disabled: 'Desativado',
}

export const FUTURE_AI_GOVERNANCE_SECTIONS = []

export const EMPTY_KNOWLEDGE_COPY = {
    title: 'A IA ainda não possui documentos de contexto.',
    body: 'Adicione manuais, procedimentos, metodologias e documentação para que o Thalamus AI possa utilizar esse conhecimento.',
    action: 'Adicionar primeiro documento',
}

export const KNOWLEDGE_EXPLANATION = [
    'Os documentos adicionados aqui formam a base de conhecimento do Thalamus AI. A IA recupera trechos relevantes do módulo atual; os arquivos completos não são enviados a cada interação.',
    'Somente documentos indexados e ativos entram nas respostas. Desativar remove o conteúdo da busca; excluir apaga arquivo e trechos.',
]

export function fileExtension(filename = '') {
    const parts = String(filename).toLowerCase().split('.')
    return parts.length > 1 ? parts.pop() : ''
}

export function isAllowedKnowledgeFile(file, maxFileMb = 20) {
    if (!file) {
        return { ok: false, message: 'Selecione um arquivo.' }
    }

    const extension = fileExtension(file.name)
    if (!KNOWLEDGE_ALLOWED_EXTENSIONS.includes(extension)) {
        return { ok: false, message: 'Envie apenas PDF textual, TXT ou Markdown.' }
    }

    const maxBytes = maxFileMb * 1024 * 1024
    if (file.size > maxBytes) {
        return { ok: false, message: `O arquivo excede o limite de ${maxFileMb} MB.` }
    }

    return { ok: true, message: null }
}

export function nameFromFilename(filename = '') {
    return String(filename).replace(/\.[^.]+$/, '').trim()
}

export function knowledgeStatusLabel(status) {
    return KNOWLEDGE_STATUS_LABELS[status] || status || '—'
}

export function knowledgeTypeLabel(type) {
    return KNOWLEDGE_TYPE_LABELS[type] || type || '—'
}

export function knowledgeScopeLabel(scope, module) {
    if (scope === 'module') {
        return module ? `Módulo ${module}` : KNOWLEDGE_SCOPE_LABELS.module
    }
    return KNOWLEDGE_SCOPE_LABELS[scope] || scope || '—'
}

export function isKnowledgeProcessing(status) {
    return status === 'processing' || status === 'uploading'
}

export function knowledgeStatusAction(status) {
    if (status === 'ready') {
        return { label: 'Desativar', targetStatus: 'disabled' }
    }
    if (status === 'disabled') {
        return { label: 'Reativar', targetStatus: 'ready' }
    }
    return null
}

export function formatKnowledgeScore(score) {
    const value = Number(score)
    if (!Number.isFinite(value)) {
        return '—'
    }
    return value.toFixed(5).replace('.', ',')
}

export function formatSearchResultMeta(result = {}) {
    const parts = []
    if (result.page) {
        parts.push(`Página ${result.page}`)
    }
    if (result.section) {
        parts.push(result.section)
    }
    if (result.version) {
        parts.push(`v${result.version}`)
    }
    return parts.join(' • ')
}

export function documentsNeedingPoll(documents = []) {
    return documents.some((document) => isKnowledgeProcessing(document?.status))
}
